import { createAction, props } from '@ngrx/store';
import { SearchResult } from '../../models';

export const GetSearchResults = createAction('[Search] Get Search Results', props<{ q: string }>());
export const GetSearchResultsSuccess = createAction('[Search] Get Search Results Success', props<{ results: SearchResult[] }>());
export const GetSearchResultsFail = createAction('[Search] Get Search Results Fail', props<{ error: any }>());

export const GetMagazineSearchResults = createAction('[Search] Get Magazine Search Results', props<{ q: string }>());
export const GetMagazineSearchResultsSuccess = createAction(
  '[Search] Get Magazine Search Results Success',
  props<{ results: SearchResult[] }>()
);
export const GetMagazineSearchResultsFail = createAction('[Search] Get Magazine Search Results Fail', props<{ error: any }>());
